import { alignItems, strCode } from "../../consts";
import { t } from "../../services";
import { withSection } from "../../hoc";
import { useCreateFWUVersion, useCreateReleaseNotes } from "../../apiHooks";

import { NewFirmwareVerionForm } from "../../containers";
import { FlexContainers, Heading5, PageContainer, WrapperContainer } from "../../components";

const CreateFwVersionPage = () => {
  const { mutationCallback: createFWUVersion, loading: createFWUVersionLoading } =
    useCreateFWUVersion();
  const { mutationCallback: createReleaseNotes, loading: createReleaseNotesLoading } =
    useCreateReleaseNotes();

  const onSaveReleaseNotes = (releaseNotes, mediaData) => {
    return createReleaseNotes(releaseNotes, mediaData);
  };

  return (
    <PageContainer alignItems={alignItems.start}>
      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width="100%">
        <Heading5>{t(strCode.NEW_FIRMWARE_TITLE)}</Heading5>

        <NewFirmwareVerionForm
          onSaveFwVersion={createFWUVersion}
          onSaveReleaseNotes={onSaveReleaseNotes}
          isLoading={createFWUVersionLoading || createReleaseNotesLoading}
        />
      </WrapperContainer>
    </PageContainer>
  );
};

export default withSection(CreateFwVersionPage);
